export default "__VITE_ASSET__DygqPRLr__"